export default __webpack_public_path__ + "static/thumb-landscape-d5788325120438e9ce4db4751b269878.jpg";